import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Modal} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {addSuccessMessage} from 'state/actions';

import ShortUrlForm from './ShortUrlForm';

const CreateModal = ({open, trigger, onCreate, onClose}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isCreating, setIsCreating] = useState(false);

  async function createShortUrl(formValues) {
    const {host, ...values} = formValues;

    setIsCreating(true);

    try {
      await httpClient.post(`/api/web-redirector/${host}/short-urls`, values);

      setIsCreating(false);
      if (onCreate) {
        onCreate();
      }

      dispatch(addSuccessMessage(`The short URL was created successfully`));

      history.push('/short-urls');
    } catch {
      setIsCreating(false);
    }
  }

  return (
    <Modal
      trigger={trigger}
      closeOnDimmerClick={!isCreating}
      closeOnDocumentClick={!isCreating}
      closeIcon={!isCreating}
      onClose={onClose}
      open={open}
    >
      <Modal.Header>Create a short URL</Modal.Header>
      <Modal.Content>
        <ShortUrlForm onSubmit={createShortUrl} loading={isCreating} />
      </Modal.Content>
    </Modal>
  );
};

CreateModal.propTypes = {
  open: PropTypes.bool,
  trigger: PropTypes.node,
  onCreate: PropTypes.func,
  onClose: PropTypes.func,
};

CreateModal.defaultProps = {
  open: false,
  trigger: undefined,
  onCreate: null,
  onClose: null,
};

export default CreateModal;
